import {register} from '../helpers/hooks'
import * as fetch from './fetch'

export default function registerContextHooks () {

  register(['language/id', 'page/'], fetch.NewsItems)

  register('page/', fetch.RecentActivity)
  register('page/', fetch.ScheduledDays)

  register('page/', fetch.GroupsDigests)
  register(['page/', 'query/', 'assessmentUpdates'], [fetch.Assessments])
  register(['assessments/', 'assessmentViewUpdates'], [fetch.AssessmentView])

  register(['language/id','page/'], fetch.Groups)

  register(['language/id', 'page/'], fetch.MyCourses)

  register(['language/id', 'course/', 'query/course'], fetch.Units)

  register(['language/id', 'unit/', 'query/unit'], fetch.Lessons)

  register(['query/languageId', 'page/', 'subject/'], [fetch.CatalogueSubjects, fetch.CatalogueCourses])
  
  register(['page/', 'query/', 'section/', 'activeTab/'], [fetch.CatalogueSearch])

  register(['query/', 'page/', 'groupId', 'section'], [fetch.StudentsDownloadLog, fetch.DownloadLog])
  register('page/', fetch.DownloadLogFilters)
  register('studentId', fetch.DownloadLog)

  register(['language/id', 'page/', 'query/', 'eventUpdates/'], fetch.Events)

  register(['query/languageId', 'page/', 'query/', 'uploadUpdates/', 'activeTab/'], [fetch.MyLessons])

  register(['query/start'], fetch.PlanningWeek)
  register(['view/'], [fetch.TeacherStandards, fetch.TeacherExpectations])

  register(['page/', 'view/', 'query/', 'planUpdates'], fetch.Plans)
  register(['page/', 'view/', 'query/template'], [fetch.NewPlan, fetch.TemplateItems, fetch.PlanTemplates, fetch.PlanRDTemplates])
  register(['templateUpdates'], [fetch.PlanTemplates, fetch.PlanRDTemplates])

  register(['section/', 'languageId/'],[fetch.DESubjects, fetch.DEGrades, fetch.DEStandards, fetch.DEExpectations])
  register(['query/grade', 'query/subject'],[fetch.DEStandards, fetch.DEExpectations])
  register(['query/standard', 'query/pattern'],[fetch.DEExpectations])

  register('openfireSettingsLoaded/', fetch.OpenfireSettings)

  register(['tab/', 'page/'],[fetch.QuizDirectories])
  register(['tab/', 'page/', 'query/', 'quizAssessmentCalls/', 'sectionName/', 'quizStandardFiltersCalls/'],[fetch.QuizAssessments])
  register(['tab/', 'page/', 'query/', 'quizBankAssessmentCalls/', 'sectionName/', 'quizStandardFiltersCalls/'],[fetch.QuizBankAssessments])
  register(['tab/', 'page/', 'query/', 'quizAssignmentCalls/', 'sectionName/', 'quizStandardFiltersCalls/'],[fetch.QuizAssignments])
  register(['tab/', 'page/', 'query/', 'quizSearchQuestionBankCalls/', 'quizDialogs/search-and-select-question/', 'sectionName/', 'quizStandardFiltersCalls/'],[fetch.QuizQuestionBank])

  register(['assignmentId/'],[fetch.QuizAssignmentAssessments])

  register(['assessment/', 'action/'],[fetch.QuizAssessment, fetch.QuizAssessmentToReview, fetch.QuizAssessmentToTake, fetch.QuizAssessmentResults])

  register(['quizBlankAssessmentForPdfId/'],[fetch.QuizBlankAssessmentForPDF])
  register(['quizAssessmentForPdfId/'],[fetch.QuizAssessmentForPDF])

  register(['page/','preferences/pendingRefresh'], [fetch.LoadPreferences])
  
  register(['page/', 'groupId/', 'query/', 'rollbookRefresh/'], [fetch.getRollbook])
  register(['rollbookContextPeriods/refreshes'], [fetch.getPeriods])
  register(['rollbookContextGrades/refreshes'], [fetch.getStudentAssignmentProperties])
  register(['rollbookContextGrades/refreshes'], [fetch.getGrades])
  register(['rollbookContextGradeColumns/refreshes'], [fetch.getGradeColumns])

  register(['page/', 'settings/dashboardVideos/'], fetch.dashboardVideos)

}
